import { lazy, Suspense } from "react";

import { Header } from "@/components/header";
import { Hero } from "@/pages/home/sections/hero";
import { NextLevel } from "@/pages/home/sections/next-level";

const NextLevelTwoStep = lazy(() => import('@/pages/home/sections/next-level-two-step').then(module => ({ default: module.NextLevelTwoStep })))
const NextLevelResult = lazy(() => import('@/pages/home/sections/next-level-result').then(module => ({ default: module.NextLevelResult })))
const Guarantee = lazy(() => import('@/pages/home/sections/guarantee').then(module => ({ default: module.Guarantee })))
const PublishStep = lazy(() => import('@/pages/home/sections/publish-step').then(module => ({ default: module.PublishStep })))
const Plans = lazy(() => import('@/pages/home/sections/plans').then(module => ({ default: module.Plans })))
const Faq = lazy(() => import('@/pages/home/sections/faq').then(module => ({ default: module.Faq })))
const Footer = lazy(() => import('@/pages/home/sections/footer').then(module => ({ default: module.Footer })))

import "./styles.scss";

export const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <NextLevel />

      <Suspense>
        <NextLevelTwoStep />
        <NextLevelResult />
        <Guarantee />
        <PublishStep />
        <Plans />
        <Faq />
        <Footer />
      </Suspense>
    </>
  );
};
